<div
  infinite-scroll 
  [infiniteScrollDisabled]="false" 
  [infiniteScrollDistance]="2" 
  [infiniteScrollThrottle]="100" 
  (scrolled)="onScroll()"
>
  <ng-container *ngIf="content?.length; else emptyList">
    <div class="list-section" *ngFor="let item of content">
        <app-drop-down-panel [title]="item.title" (onToggle)="onExpandTrack($event, item.id)">
          <ng-container *ngIf="getModules(item.id)?.length else loader">
            <div class="list-item" *ngFor="let module of getModules(item.id)" (click)="openPreviewModal.next(module)">
              <div class="list_point"></div>
              <span class="p4">{{module.title}}</span>
            </div>
          </ng-container>
        </app-drop-down-panel>
    </div>
  </ng-container>
</div>

<ng-template #loader>
  <app-spinner class="list-loader"></app-spinner>
</ng-template>

<ng-template #emptyList>
  <span class="p1 placeholder">No Sharpen content available to add</span>
</ng-template>

<app-adaptive-modal [title]="previewModule?.title" [showModal]="openPreviewModal" [fullscreen]="true">
  <div class="preview">
    <div class="preview-content" *ngIf="previewModule">
      <app-sharpen-content
        [content]="previewModule"
        [creationMode]="true"
      ></app-sharpen-content>
    </div>
    <div class="preview-action">
      <app-button
          title="Add to Post"
          icon="attach-white"
          [style]="'filled stretch'"
          (onCLick)="addContent(previewModule.id)"
          [default]="true"
        ></app-button>
    </div>
  </div>
</app-adaptive-modal>